module.exports = __webpack_public_path__ + "static/img/education_quiz_icon.3f5c304f.jpg";